module.exports = __webpack_public_path__ + "media/iconic/trash-6c4515f2.svg";